import { queryStringify } from 'lib/utils/page'
import { DOMAIN } from 'src/constants/environment'
import { MarketType } from 'src/types/market'

export function isTestInstance(hostname: string): boolean {
  const regex = /\.test/
  return regex.test(hostname)
}

export function buildLocationURL(
  country: MarketType,
  toHomepage: boolean,
  windowLocation: Location | null = null
): string {
  const { hostname, pathname, protocol } = windowLocation || window.location
  const isInstance = isTestInstance(hostname)
  const domain = isInstance ? hostname : DOMAIN

  const { market, language, subdomain, topdomain } = country
  const pathName = toHomepage ? '' : pathname

  if (isInstance) {
    return `${protocol}//${domain}${pathName}?market=${market}&lang=${language}`
  }

  const subDomain = subdomain || 'www'
  const topDomain = topdomain && !isInstance ? topdomain : 'com'

  return `${protocol}//${subDomain}.${domain}.${topDomain}${pathName}?market=${market}&lang=${language}`
}

interface SearchQuery {
  checkIn: string
  checkOut: string
  adults: number[]
  children: number[][]
}

export function buildSearchQuery({ checkIn, checkOut, adults, children }: SearchQuery): string {
  const dates = { checkin: checkIn, checkout: checkOut }
  const paxes = queryStringify({ adults, children })

  // Ensure all values are strings
  const params: Record<string, string> = {}
  Object.entries({ ...dates, ...paxes }).forEach(([key, value]) => {
    params[key] = String(value)
  })

  return new URLSearchParams(params).toString()
}
